import App from "./modules/app";

new App();
